import { Component, Input } from '@angular/core';
import type { FormControl, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { BehaviorSubject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import { InputComponent } from '@core/user-interface-legacy';

import type { InputTypeComponent } from '../../advanced-filters/filter/types';

type InputTextControl = FormGroup<{ data: FormControl<string> }>;
type InputText = InputTypeComponent<InputTextControl, never, never>;

@Component({
  selector: 'rt-views-filter-text',
  imports: [InputComponent, ReactiveFormsModule, TranslatePipe],
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.less'],
})
export class InputTextComponent implements InputText {
  @Input() public inputControl: InputText['inputControl'];
  @Input() public state: InputText['state'] = null;
  @Input() public optionsData: InputText['optionsData'];

  public state$ = new BehaviorSubject<null>(null);
}
